import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyButtonProps {
  text: string;
  ariaLabel?: string;
  className?: string;
}

export function CopyButton({
  text,
  ariaLabel = "Copy to clipboard",
  className = "",
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-label={copied ? "Copied" : ariaLabel}
      className={`
        relative p-1.5 rounded-lg transition-colors
        focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50
        cursor-pointer
        ${className}
      `}
    >
      {copied ? (
        <Check
          className="w-4 h-4 text-green-600 dark:text-green-400"
          aria-hidden="true"
        />
      ) : (
        <Copy
          className="w-4 h-4 text-gray-600 dark:text-gray-400"
          aria-hidden="true"
        />
      )}
      {copied && (
        <span className="sr-only" role="status">
          Copied to clipboard
        </span>
      )}
    </button>
  );
}
